module.exports = __webpack_public_path__ + "img/feature_buy_en.5ad0e91d.png";